import {useAuthQuery} from "#lib/hooks/use-query.js";
import {fetchAndParse} from "#lib/helpers/fetch.js";

export function useGiacenzeDeposito(sourceWarehouse, porzionato, idprodotto) {
    const {data, isSuccess, ...queryProps} = useAuthQuery({
        queryKey: ['giacenzeDeposito'],
        staleTime: 'Infinity',
        refetchOnWindowFocus: false,
        retry: false,
        retryOnMount: false,
        queryFn: (_, headers) =>
            fetchAndParse(`${API_URL}/p/giacenze/giacenzeDeposito?deposito=${sourceWarehouse || ''}&porzionato=${porzionato}&idprodotto=${idprodotto || ''}`, {
                headers
            })
    });

    return {data: data?.results, ...queryProps, isSuccess};
}